declare namespace $ {

	export class $bog_wikilive_logo extends $mol_icon_molecule {
	}
	
}

//# sourceMappingURL=logo.view.tree.d.ts.map